var React = require('react');
var Pumper = require('../_common/Pumper');

var createSprite = require('../../../lib/createSprite');
var Utils = require('../../../lib/utils');

var BaldGuyPump = React.createClass({

    propTypes: {
        backgroundKey: React.PropTypes.string,
        movieclipKeys: React.PropTypes.array,
        fluxSettings: React.PropTypes.object
    },

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: 'Dave FORSYTHE',
                    subtitle: 'Banquier d\'investissement',
                    opts: {
                        x: 50,
                        y: 215,
                        croppedY: 280,
                    }
                }
            ],
            className: 'bald-guy-pump',
            backgroundKey: 'baldGuyPumpBackground',
            movieclipKeys: ['pumperBaldGuy'],
            pumperKey: 'pumperBaldGuy',
            pumpKey: 'baldGuyPump',
            fluxSettings: require('../../../flux/baldGuyPump'),
            nextFrameMaskGradientStart: 1,
            nextFrameMaskGradientEnd: 1
        };
    },

    render: function()
    {
        return (
            <Pumper
                onBeforeObjectsBuild={this.onBeforeObjectsBuild}
                title={'dave'}
                role={'dave_title'}
                {...this.props}
                hasGuillotine={false}
            />
        );
    },

    onBeforeObjectsBuild: function(container, timeline)
    {
        var props = this.props;
        var objs = props.objs;

        var diplomeObj = objs.diplomeBaldGuy;
        var diplome = createSprite(diplomeObj);
        Utils.setSizeAndPositionFromRefSize(diplome, props.width, props.height, diplomeObj);
        container.addChild(diplome);
    }
});

module.exports = BaldGuyPump;



// WEBPACK FOOTER //
// ./js/components/frames/A-Remuneration/5-BaldGuyPump.jsx